module.exports = __webpack_public_path__ + "img/waterfront-homes.027b6463.jpg";